import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  background: #fff;
  padding: 32px 48px 64px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }

  .expert-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .back-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #fff;
    background: #007bff;
    border: none;
    border-radius: 999px;
    font-size: 14px;
    padding: 8px 16px;
    margin-bottom: 24px;
    cursor: pointer;

    i {
      font-size: 18px;
    }

    &:hover {
      background: #0069d9;
    }
  }

  .profile-card {
    position: relative;
    border: 1px solid #e8e2de;
    border-radius: 20px;
    padding: 28px;
    margin-bottom: 32px;
    overflow: hidden;
    background: #fff;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #2eb872 0%, #2b6a4e 100%);
    }

    .profile-head {
      display: flex;
      gap: 22px;
      align-items: flex-start;
    }
  }

  .expert-photo {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: #2b6a4e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-weight: 600;
    flex-shrink: 0;
    object-fit: cover;
  }

  .expert-name {
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
  }

  .expert-role {
    font-size: 15px;
    color: #718096;
    margin-bottom: 14px;
  }

  .expert-bio {
    font-size: 15px;
    line-height: 1.6;
    color: #6b7280;
    margin: 0 0 18px;
  }

  .profile-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .prompts-badge,
  .instagram-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;

    i {
      font-size: 16px;
      color: #2b6a4e;
    }
  }

  a.instagram-badge {
    cursor: pointer;
    text-decoration: none;
    transition: border-color 0.2s ease, color 0.2s ease;

    &:hover {
      border-color: #2b6a4e;
      color: #2b6a4e;
    }
  }

  .expert-search {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    padding: 14px 22px;
    margin-bottom: 18px;
    background: #fff;

    &:focus-within {
      border-color: #2b6a4e;
    }

    i {
      font-size: 22px;
      color: #a0aec0;
    }

    input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: 15px;
      color: #2a2a2a;

      &::placeholder {
        color: #a0aec0;
      }
    }
  }

  .expert-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 32px;

    .category-chip {
      border: 1px solid #e2e8f0;
      background: #fff;
      color: #4a5568;
      border-radius: 999px;
      padding: 7px 15px;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.15s;

      &:hover {
        border-color: #cbd5e0;
        background: #f7fafc;
      }

      &.active {
        background: #2b6a4e;
        border-color: #2b6a4e;
        color: #fff;
      }
    }
  }

  .prompts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }

  .prompt-card {
    display: flex;
    flex-direction: column;
    border: 1px solid #e8e2de;
    border-radius: 16px;
    padding: 22px;
    background: #fff;
    transition: box-shadow 0.15s, border-color 0.15s;

    &:hover {
      border-color: #bfe0cf;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
    }

    .prompt-card-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 12px;
    }

    .prompt-title {
      font-size: 18px;
      font-weight: 700;
      color: #1a1a1a;
      line-height: 1.3;
    }

    .topic-chip {
      flex-shrink: 0;
      font-size: 12px;
      color: #4a5568;
      background: #f4f4f5;
      border: 1px solid #e8e8ec;
      border-radius: 999px;
      padding: 4px 10px;
      white-space: nowrap;
    }

    .prompt-summary {
      font-size: 14px;
      color: #6b7280;
      line-height: 1.6;
      margin: 0 0 20px;
      flex: 1;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .prompt-card-foot {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .use-button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      border: none;
      border-radius: 999px;
      padding: 9px 18px;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      background: linear-gradient(135deg, #2eb872 0%, #2b6a4e 100%);
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        filter: brightness(0.96);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .copy-button {
      width: 38px;
      height: 38px;
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e2e8f0;
      border-radius: 50%;
      background: #fff;
      color: #4a5568;
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        background: #f7fafc;
      }
    }

    .full-button {
      display: inline-flex;
      align-items: center;
      gap: 2px;
      margin-left: auto;
      border: none;
      background: none;
      color: #6b7280;
      font-size: 14px;
      cursor: pointer;

      i {
        font-size: 18px;
      }

      &:hover {
        color: #2a2a2a;
      }
    }
  }

  .library-empty {
    color: #a0aec0;
    font-size: 15px;
    padding: 24px 0;
  }
`;
